import { Flex, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { SquareArrowOutUpRight } from 'lucide-react';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

type Props = {
  title: string;
  titleIcon?: React.ReactElement;
  titleColour?: string;
  description?: string;
  descriptionColour?: string;
  backgroundColour?: string;
  value?: number | string;
  valueColour?: string;
  to?: string;
};

export default function HealthStatCard({
  title,
  titleColour = 'fg.subtle',
  description,
  descriptionColour = 'fg.subtle',
  backgroundColour = 'bg.canvas',
  value = '-',
  valueColour = 'fg.emphasis',
  to,
}: Props) {
  return (
    <VStack
      bg="bg.subtle"
      borderRadius="2xl"
      w="full"
      backgroundColor={backgroundColour}
      py="1"
      pl="3"
      pr="2"
      gap="1"
      flex="1"
      minHeight={pxToRem(108)}
      alignItems="flex-start"
      justifyContent="space-between"
    >
      <HStack w="full" pt="1" gap="2" justifyContent="space-between">
        <Text fontSize="sm" fontWeight="medium" color={titleColour}>
          {title}
        </Text>

        {to !== undefined ? (
          <Link to={to} color="fg.subtle">
            <Icon as={SquareArrowOutUpRight} boxSize="0.875rem" color="fg.subtle" />
          </Link>
        ) : null}
      </HStack>

      <Flex alignItems="flex-end" justifyContent="space-between" w="full" gap="3">
        <Text fontSize="xs" fontWeight="medium" color={descriptionColour} pr="2" pb="1.5">
          {description}
        </Text>

        <Text fontSize="2xl" fontWeight="medium" textAlign="right" color={valueColour} pr="1">
          {value}
        </Text>
      </Flex>
    </VStack>
  );
}
